(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["manufacturing-estimate"] && !Shopify.designMode) return;
  try {
    function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  function isHoliday(date, holidays) {
    const iso = date.toISOString().slice(0, 10);
    return holidays.includes(iso);
  }

  function addBusinessDays(startDate, days, holidays) {
    const date = new Date(startDate.getTime());
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (!isWeekend(date) && !isHoliday(date, holidays)) {
        added += 1;
      }
    }
    return date;
  }

  function updateManufacturingEstimates() {
    const estimateSections = document.querySelectorAll('.manufacturing-estimate');

    estimateSections.forEach((section) => {
      const baseDaysAttr = section.getAttribute('data-base-days');
      const baseDays = parseInt(baseDaysAttr || '0', 10);
      if (!baseDays || Number.isNaN(baseDays)) return;

      const todayIso = section.getAttribute('data-today');
      const holidaysAttr = section.getAttribute('data-holidays') || '';
      const loadingText = section.getAttribute('data-loading-text') || '';
      const messageTemplate = section.getAttribute('data-message-template') || '';

      const holidays = holidaysAttr
        .split(',')
        .map((d) => d.trim())
        .filter((d) => d.length > 0);

      const today = todayIso ? new Date(todayIso) : new Date();
      const completionDate = addBusinessDays(today, baseDays, holidays);

      const locale = document.documentElement.lang || 'en';
      const formatted = completionDate.toLocaleDateString(locale, {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });

      const textEl = section.querySelector('[data-estimate-text]');
      if (!textEl) return;

      if (messageTemplate) {
        textEl.textContent = messageTemplate.replace('[[date]]', formatted);
      } else if (loadingText) {
        textEl.textContent = loadingText;
      } else {
        textEl.textContent = formatted;
      }

      if (section.dataset.context === 'cart') {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { 'Estimated ship date': formatted }
          })
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateManufacturingEstimates);
  } else {
    updateManufacturingEstimates();
  }

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;

          if (
            node.classList.contains('manufacturing-estimate') ||
            node.querySelector('.manufacturing-estimate')
          ) {
            shouldUpdate = true;
            break;
          }
        }
        if (shouldUpdate) break;
      }

      if (shouldUpdate) {
        updateManufacturingEstimates();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  } catch(e) { console.error(e); }
})();

})();
